import React, { useEffect, useRef, useState } from "react";
import TableContainer from "@mui/material/TableContainer";
import EditIcon from "@mui/icons-material/Edit";
import HistoryIcon from "@mui/icons-material/History";
import LockIcon from "@mui/icons-material/Lock";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import Paper from "@mui/material/Paper";
import Dialog from "@mui/material/Dialog";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MyTable from "./Table";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import IconButton from "@mui/material/IconButton";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import PasswordIcon from "@mui/icons-material/Password";
import AddCardIcon from "@mui/icons-material/AddCard";
import moment from "moment";
import ApiConfig from "../../common/config/ApiConfig";
import showValidateErrors from "../../common/utils/showValidateErrors";
import { useLocation } from "react-router-dom";
import MemberCommissionTables, {
  emptyThaiCommission,
  emptySixFieldCommission,
  commissionTablesFromRows,
} from "./PageComponents/Member/CommissionTables";
import { useLanguage } from "../../common/i18n/LanguageContext";

export default function CustomizedTables({ packages }) {
  const { t } = useLanguage();
  const [member, setMember] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [userid, setUserid] = useState(null);
  const [username, setUsername] = useState();

  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [phone, setPhone] = useState("");
  const [bank, setBank] = useState("");
  const [banknumber, setBanknumber] = useState("");
  const [reload, setReload] = useState(0);

  const [thCommission, setThCommission] = useState(emptyThaiCommission());
  const [hanoiCommission, setHanoiCommission] = useState(
    emptySixFieldCommission(),
  );
  const [laosCommission, setLaosCommission] = useState(
    emptySixFieldCommission(),
  );
  const [yeekee5Commission, setYeekee5Commission] = useState(
    emptySixFieldCommission(),
  );
  const [yeekee10Commission, setYeekee10Commission] = useState(
    emptySixFieldCommission(),
  );
  const [yeekee15Commission, setYeekee15Commission] = useState(
    emptySixFieldCommission(),
  );
  const originalCommissionRef = useRef(commissionTablesFromRows());
  const [openAddCredit, setOpenAddCredit] = useState(false);
  const [creditMember, setCreditMember] = useState("");
  const [creditAmount, setCreditAmount] = useState("");
  const [currencyCodeById, setCurrencyCodeById] = useState({});

  useEffect(() => {
    ApiConfig.get("/getCurrencyList").then((result) => {
      if (result.resCode !== 200) return;
      const list = Array.isArray(result.data) ? result.data : [];
      setCurrencyCodeById(Object.fromEntries(list.map((c) => [c.id, c.code])));
    });
  }, []);

  const pos = localStorage.getItem("position");
  const user = localStorage.getItem("user");

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const byAgent = searchParams.get("username");
  const seniorParam = searchParams.get("senior");
  const masterParam = searchParams.get("master");
  const agentParam = searchParams.get("agent");

  // Drill-down breadcrumb (e.g. "MS01 \ MS0101 \ MS010101") — mirrors
  // Agenttable.jsx, one clickable crumb per level already drilled into.
  const drillDownCrumbs = [];
  if (seniorParam) {
    drillDownCrumbs.push({
      label: seniorParam,
      href: `/agent?username=${seniorParam}&level=master&senior=${seniorParam}`,
    });
  }
  if (masterParam) {
    drillDownCrumbs.push({
      label: masterParam,
      href: `/agent?username=${masterParam}&level=agent&senior=${seniorParam}&master=${masterParam}`,
    });
  }
  if (agentParam) {
    drillDownCrumbs.push({
      label: agentParam,
      href: `/member?username=${agentParam}&level=member&senior=${seniorParam}&master=${masterParam}&agent=${agentParam}`,
    });
  }

  // `packages` comes from Member.jsx (its parent) as a prop now — it fetches
  // the exact same `/getAgentPackageList?username=${byAgent ?? user}` list
  // for its own add-member dialog, so this table no longer needs its own
  // duplicate fetch of the same data. A member picks its own package per
  // lotto_type though (packageIds, keyed by raw lotto_type — set from the
  // member's own data in applyCommissionPrefill below).
  const [packageIds, setPackageIds] = useState({});

  const MemberGet = async () => {
    await ApiConfig.get(
      `/member?user=${encodeURIComponent(byAgent ?? user)}`,
    ).then((result) => {
      if (result.resCode !== 200) {
        toast.error(result.message || t("common_load_error"), {
          position: "top-right",
          autoClose: 3000,
        });
        return;
      }
      setMember(
        result.data.map(({ memberCommissions, ...rest }) => ({
          ...rest,
          commission: memberCommissions,
        })),
      );
    });
  };

  const subuserid = localStorage.getItem("subuserid");
  const [permission, setPermission] = useState({ member_credit_update: 1 });
  const permissionGet = async () => {
    await ApiConfig.get(
      `/getpermissionid?id=${encodeURIComponent(subuserid)}`,
    ).then((result) => {
      if (result.resCode !== 200) {
        toast.error(result.message || t("common_load_error"), {
          position: "top-right",
          autoClose: 3000,
        });
        return;
      }
      if (pos === "sub_account") {
        setPermission(result.data);
      }
    });
  };

  useEffect(() => {
    MemberGet();
    permissionGet();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  const handleDeletemember = (user) => {
    if (pos === "sub_account") {
      if (permission.edit_member === 1) {
        Swal.fire({
          title: t("membertable_delete_confirm_title"),
          text: [
            t("membertable_delete_confirm_text_prefix"),
            user,
            t("membertable_delete_confirm_text_suffix"),
          ]
            .filter(Boolean)
            .join(" "),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: t("common_confirm"),
          cancelButtonText: t("common_cancel"),
        }).then((result) => {
          if (result.isConfirmed) {
            const jsonid = {
              username: user,
            };
            ApiConfig.post("/deletemember", jsonid)
              .then((result) => {
                if (result.resCode === 200) {
                  toast.success(t("membertable_delete_success"), {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  });
                  setReload(reload + 1);
                } else {
                  toast.error(result.message || t("membertable_delete_error"), {
                    position: "top-right",
                    autoClose: 3000,
                  });
                }
              })
              .catch(() => {
                toast.error(t("membertable_delete_error"), {
                  position: "top-right",
                  autoClose: 3000,
                });
              });
          }
        });
      } else {
        alert(t("common_no_permission"));
      }
    } else {
      Swal.fire({
        title: t("membertable_delete_confirm_title"),
        text: [
          t("membertable_delete_confirm_text_prefix"),
          user,
          t("membertable_delete_confirm_text_suffix"),
        ]
          .filter(Boolean)
          .join(" "),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: t("common_confirm"),
        cancelButtonText: t("common_cancel"),
      }).then((result) => {
        if (result.isConfirmed) {
          const jsonid = {
            username: user,
          };
          ApiConfig.post("/deletemember", jsonid)
            .then((result) => {
              if (result.resCode !== 200) {
                toast.error(result.message || t("membertable_delete_error"), {
                  position: "top-right",
                  autoClose: 3000,
                });
                return;
              }
              toast.success(t("membertable_delete_success"), {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
              setReload(reload + 1);
            })
            .catch(() => {
              toast.error(t("membertable_delete_error"), {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            });
        }
      });
    }
  };

  // Table's lock cell — click anywhere on the cell to toggle, regardless of
  // whether the icon is currently shown (it only shows while locked).
  const handleToggleMemberLock = (username, isLocked) => {
    Swal.fire({
      title: t("agent_lock_confirm_title"),
      text: isLocked
        ? t("agent_lock_confirm_text_unlock")
        : t("agent_lock_confirm_text_lock"),
      icon: "warning",
      iconHtml: isLocked ? "🔓" : "🔒",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("common_yes"),
      cancelButtonText: t("common_no"),
    }).then((result) => {
      if (!result.isConfirmed) return;
      ApiConfig.put(`/updatemember/lock/${username}`, { lock: !isLocked })
        .then((res) => {
          if (res.resCode !== 200) {
            toast.error(res.message || t("agent_lock_error"), {
              autoClose: 2000,
            });
            return;
          }
          toast.success(t("agent_lock_success"), { autoClose: 2000 });
          setReload(reload + 1);
        })
        .catch(() => {
          toast.error(t("agent_lock_error"), { autoClose: 2000 });
        });
    });
  };

  // Table's status cell — click to open a select dropdown of the 3 status
  // values. Switching to "inactive" gets its own extra confirm on top of
  // the picker, since that permanently zeroes this member's own
  // MemberCommission rows (see updateMemberStatus in member.service.ts) —
  // not reversible by switching back to "active".
  const handleEditMemberStatus = (username, currentStatus) => {
    Swal.fire({
      title: t("agent_status_confirm_title"),
      input: "select",
      inputOptions: {
        active: t("agentadd_status_active"),
        inactive: t("agentadd_status_inactive"),
        suspend: t("agentadd_status_suspend"),
      },
      inputValue: currentStatus,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("common_yes"),
      cancelButtonText: t("common_no"),
    }).then((result) => {
      if (!result.isConfirmed) return;
      const newStatus = result.value;
      if (!newStatus || newStatus === currentStatus) return;

      const applyStatus = () => {
        ApiConfig.put(`/updatemember/status/${username}`, {
          status: newStatus,
        })
          .then((res) => {
            if (res.resCode !== 200) {
              toast.error(res.message || t("agent_lock_error"), {
                autoClose: 2000,
              });
              return;
            }
            toast.success(t("agent_lock_success"), { autoClose: 2000 });
            setReload(reload + 1);
          })
          .catch(() => {
            toast.error(t("agent_lock_error"), { autoClose: 2000 });
          });
      };

      if (newStatus === "inactive") {
        Swal.fire({
          icon: "warning",
          title: t("member_status_inactive_warning_title"),
          text: t("member_status_inactive_warning_text"),
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: t("common_yes"),
          cancelButtonText: t("common_no"),
        }).then((confirmResult) => {
          if (confirmResult.isConfirmed) applyStatus();
        });
      } else {
        applyStatus();
      }
    });
  };

  const applyCommissionPrefill = (user) => {
    const memberRow = member.find((m) => m.Username === user);
    const tables = commissionTablesFromRows(memberRow?.commission);
    originalCommissionRef.current = tables;
    setThCommission(tables.thCommission);
    setHanoiCommission(tables.hanoiCommission);
    setLaosCommission(tables.laosCommission);
    setYeekee5Commission(tables.yeekee5Commission);
    setYeekee10Commission(tables.yeekee10Commission);
    setYeekee15Commission(tables.yeekee15Commission);
    // Every row for a given lotto_type carries the same package, but
    // different lotto_types can differ — build one entry per type from
    // whichever row happens to represent it.
    const packageIdsByType = {};
    (memberRow?.commission ?? []).forEach((row) => {
      if (row.package?.id != null && !(row.lotto_type in packageIdsByType)) {
        packageIdsByType[row.lotto_type] = String(row.package.id);
      }
    });
    setPackageIds(packageIdsByType);
  };

  const handleClickOpen = (user) => {
    const jsonid = {
      user: user,
    };
    if (pos === "sub_account") {
      if (permission.edit_member === 1) {
        setOpen(true);
        ApiConfig.post("/profile", jsonid).then((result) => {
          if (result.resCode === 200) {
            const data = result.data;
            setUserid(data);
            setFname(data.f_name);
            setLname(data.l_name);
            setPhone(data.phone);
            setBank(data.bank);
            setBanknumber(data.bankaccoutnumber);
            applyCommissionPrefill(user);
          } else {
            toast.error(result.message, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });
      } else {
        alert(t("common_no_permission"));
      }
    } else {
      setOpen(true);
      ApiConfig.post("/profile", jsonid).then((result) => {
        if (result.resCode === 200) {
          const data = result.data;
          setUserid(data);
          setFname(data.f_name);
          setLname(data.l_name);
          setPhone(data.phone);
          setBank(data.bank);
          setBanknumber(data.bankaccoutnumber);
          applyCommissionPrefill(user);
        } else {
          toast.error(result.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      });
    }
  };

  const handleUpdate = (username) => {
    setOpen(false);
    Swal.fire({
      title: t("membertable_update_confirm_title"),
      text: `${t("membertable_update_confirm_text_prefix")} : ${username}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("common_confirm"),
      cancelButtonText: t("common_cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        const jsonid = {
          username: username,
          fname: fname,
          lname: lname,
          phone: phone,
          bank: bank,
          bankacc: banknumber,
          ...(packageIds.th_gov && { th_package_id: packageIds.th_gov }),
          ...(packageIds.hanoy_PhuQua && {
            hanoi_package_id: packageIds.hanoy_PhuQua,
          }),
          ...(packageIds.laos_gov && { laos_package_id: packageIds.laos_gov }),
          ...(packageIds.Yeekee_5 && {
            yeekee5_package_id: packageIds.Yeekee_5,
          }),
          ...(packageIds.Yeekee_10 && {
            yeekee10_package_id: packageIds.Yeekee_10,
          }),
          ...(packageIds.Yeekee_15 && {
            yeekee15_package_id: packageIds.Yeekee_15,
          }),
          ...(JSON.stringify(thCommission) !==
            JSON.stringify(originalCommissionRef.current.thCommission) && {
            th_commission: thCommission,
          }),
          ...(JSON.stringify(hanoiCommission) !==
            JSON.stringify(originalCommissionRef.current.hanoiCommission) && {
            hanoi_commission: hanoiCommission,
          }),
          ...(JSON.stringify(laosCommission) !==
            JSON.stringify(originalCommissionRef.current.laosCommission) && {
            laos_commission: laosCommission,
          }),
          ...(JSON.stringify(yeekee5Commission) !==
            JSON.stringify(originalCommissionRef.current.yeekee5Commission) && {
            yeekee5_commission: yeekee5Commission,
          }),
          ...(JSON.stringify(yeekee10Commission) !==
            JSON.stringify(
              originalCommissionRef.current.yeekee10Commission,
            ) && {
            yeekee10_commission: yeekee10Commission,
          }),
          ...(JSON.stringify(yeekee15Commission) !==
            JSON.stringify(
              originalCommissionRef.current.yeekee15Commission,
            ) && {
            yeekee15_commission: yeekee15Commission,
          }),
        };
        ApiConfig.post("/updatemember", jsonid)
          .then((result) => {
            if (result.resCode === 200) {
              toast.success(t("membertable_update_success"), {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
              setReload(reload + 1);
              handleClose();
            } else {
              toast.error(result.message || t("membertable_update_error"), {
                position: "top-right",
                autoClose: 3000,
              });
            }
          })
          .catch(() => {
            toast.error(t("membertable_update_error"), {
              position: "top-right",
              autoClose: 3000,
            });
          });
      }
    });
  };

  const handleClose = () => {
    setOpen(false);
    setUserid(null);
    setFname("");
    setLname("");
    setPhone("");
    setBank("");
    setBanknumber("");
    setThCommission(emptyThaiCommission());
    setHanoiCommission(emptySixFieldCommission());
    setLaosCommission(emptySixFieldCommission());
    setYeekee5Commission(emptySixFieldCommission());
    setYeekee10Commission(emptySixFieldCommission());
    setYeekee15Commission(emptySixFieldCommission());
    setPackageIds({});
    originalCommissionRef.current = commissionTablesFromRows();
  };

  const handleOpenAddCredit = (username) => {
    setCreditMember(username);
    setCreditAmount("");
    setOpenAddCredit(true);
  };

  const handleCloseAddCredit = () => {
    setOpenAddCredit(false);
    setCreditMember("");
    setCreditAmount("");
  };

  const handleSubmitAddCredit = () => {
    const amount = parseInt(creditAmount);
    if (!creditAmount || isNaN(amount) || amount <= 0) {
      toast.error(t("membertable_credit_invalid"), {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }
    const useradmin = localStorage.getItem("user");
    Swal.fire({
      title: t("membertable_add_credit_confirm_title"),
      text: `${t("membertable_add_credit_confirm_text_prefix")} ${amount} ${t("membertable_add_credit_confirm_text_middle")} : ${creditMember}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("common_confirm"),
      cancelButtonText: t("common_cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        ApiConfig.post("/updatemembercredit", {
          adminusername: byAgent ?? useradmin,
          updateamout: amount,
          username: creditMember,
        })
          .then((res) => {
            if (res.resCode !== 200) {
              Swal.fire(
                t("common_error"),
                t("membertable_add_credit_insufficient"),
                "error",
              );
            } else {
              toast.success(
                `${t("membertable_add_credit_success_prefix")} ${amount} ${t("membertable_add_credit_success_middle")} : ${creditMember} ${t("membertable_add_credit_success_suffix")}`,
                {
                  position: "top-right",
                  autoClose: 3000,
                },
              );
              handleCloseAddCredit();
              setReload((r) => r + 1);
            }
          })
          .catch(() => {
            toast.error(t("membertable_add_credit_error"), {
              position: "top-right",
              autoClose: 3000,
            });
          });
      }
    });
  };

  // #region password edit

  const [openeditpassword, setOpeneditpassword] = React.useState(false);
  const [password, setPassword] = useState();

  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleClickOpenpassword = (username) => {
    if (pos === "sub_account") {
      if (permission.edit_member === 1) {
        setUsername(username);
        setOpeneditpassword(true);
      } else {
        alert(t("common_no_permission"));
      }
    } else {
      setUsername(username);
      setOpeneditpassword(true);
    }
  };

  const handleClosepassword = () => {
    setOpeneditpassword(false);
    setUsername();
    setPassword();
  };

  const handleChangepassword = (event) => {
    setPassword(event.target.value);
  };

  const handleUpdatepassword = (password) => {
    const jsonid = {
      Username: username,
      Password: password,
    };

    Swal.fire({
      title: t("membertable_change_password_title"),
      text: t("membertable_change_password_text"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: t("common_confirm"),
      cancelButtonText: t("common_cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        ApiConfig.post("/memberpasswordchange", jsonid)
          .then((result) => {
            if (result.resCode === 422) {
              showValidateErrors(result.errors);
              return;
            }
            if (result.resCode !== 200) {
              toast.error(
                result.message || t("membertable_change_password_error"),
                {
                  position: "top-right",
                  autoClose: 3000,
                },
              );
              return;
            }
            toast.success(t("membertable_change_password_success"), {
              position: "top-right",
              autoClose: 3000,
            });
          })
          .catch(() => {
            toast.error(t("membertable_change_password_error"), {
              position: "top-right",
              autoClose: 3000,
            });
          });
      }
    });

    handleClosepassword(); // Close the password dialog regardless of the user's choice
  };

  // #endregion

  // memberColumns is rendered as a plain <table> below instead of through
  // MyTable/react-table — same reason as Agenttable.jsx: MUI's <Table>
  // forces width:100% on its root regardless of className, and once every
  // column is content-sized that leaves no flexible column to absorb the
  // leftover width, so auto table layout spreads it evenly across all of
  // them instead of shrinking. A native table with no width forced on it
  // just sizes to its content.
  const [memberSearchName, setMemberSearchName] = useState("");
  const [memberSearchPhone, setMemberSearchPhone] = useState("");
  const [memberSearchAccount, setMemberSearchAccount] = useState("");
  const [filteredMemberRows, setFilteredMemberRows] = useState([]);

  useEffect(() => {
    setFilteredMemberRows(Array.isArray(member) ? member : []);
  }, [member]);

  const handleSearchMemberClick = () => {
    const filtered = (Array.isArray(member) ? member : []).filter((item) => {
      const matchName =
        memberSearchName === "" || item.Username?.includes(memberSearchName);
      const matchPhone =
        memberSearchPhone === "" || item.phone?.includes(memberSearchPhone);
      const matchAccount =
        memberSearchAccount === "" ||
        item.bankaccoutnumber?.includes(memberSearchAccount);
      return matchName && matchPhone && matchAccount;
    });
    setFilteredMemberRows(filtered);
  };

  const memberColumns = [
    {
      Header: t("membertable_col_no"),
      align: "center",
      widthClass: "w-[50px]",
      width: 50,
      Cell: ({ row }) => (
        <span className="font-bold text-[9px] md:text-[11px]">
          {row.index + 1}
        </span>
      ),
    },
    {
      Header: t("login_username_label"),
      accessor: "Username",
      align: "center",
      Cell: ({ value }) => (
        <span className="font-bold text-[9px] md:text-[11px]">{value}</span>
      ),
    },
    {
      Header: t("membertable_col_name"),
      accessor: (row) => `${row.f_name} ${row.l_name}`,
      align: "right",
      Cell: ({ value }) => (
        <span className="text-[9px] md:text-[11px]">{value}</span>
      ),
    },
    {
      Header: t("membertable_col_phone"),
      accessor: "phone",
      align: "right",
      Cell: ({ value }) => (
        <span className="font-bold text-[9px] md:text-[11px]">{value}</span>
      ),
    },
    {
      Header: t("member_bank_account_number"),
      accessor: "bankaccoutnumber",
      align: "right",
      Cell: ({ value }) => (
        <span className="text-[9px] md:text-[11px]">{value}</span>
      ),
    },
    {
      Header: t("member_bank"),
      accessor: "bank",
      align: "right",
      Cell: ({ value }) => (
        <span className="font-bold text-[9px] md:text-[11px]">{value}</span>
      ),
    },
    {
      Header: t("membertable_col_credit"),
      accessor: "credit",
      align: "right",
      Cell: ({ row, value }) => {
        const floatValue = parseFloat(value);
        let textColorClass = "text-slate-400"; // Default to black

        if (floatValue > 0) {
          textColorClass = "text-sky-600"; // Change to green for positive values
        } else if (floatValue < 0) {
          textColorClass = "text-red-600"; // Change to red for negative values
        }

        return (
          <>
            <div className="flex flex-row items-center justify-end space-x-1">
              <span
                className={`font-bold text-[9px] md:text-[11px] ${textColorClass}`}
              >
                {floatValue.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}{" "}
                {currencyCodeById[row.original.currency_id]}
              </span>
              <button
                onClick={() => gettransaction(row.original.Username)}
                className="text-slate-600 no-underline hover:text-slate-800"
              >
                <HistoryIcon sx={{ fontSize: 16 }} />
              </button>

              <button
                onClick={() => handleOpenAddCredit(row.original.Username)}
                className="bg-green-500 text-white hover:bg-green-700 p-1 rounded flex items-center justify-center"
              >
                <AddCardIcon sx={{ fontSize: 16 }} />
              </button>
            </div>
          </>
        );
      },
    },
    {
      Header: t("agent_col_status"),
      accessor: "status",
      align: "center",
      Cell: ({ value, row }) => {
        let colorClass = "bg-slate-100 text-slate-800";
        let label = value;
        if (value === "active") {
          colorClass = "bg-green-100 text-green-800";
          label = t("agentadd_status_active");
        } else if (value === "inactive") {
          colorClass = "bg-slate-200 text-slate-700";
          label = t("agentadd_status_inactive");
        } else if (value === "suspend") {
          colorClass = "bg-red-100 text-red-800";
          label = t("agentadd_status_suspend");
        }
        return (
          <button
            type="button"
            onClick={() => handleEditMemberStatus(row.original.Username, value)}
            className="w-full text-center"
          >
            <span
              className={`inline-block px-2 py-0.5 rounded-full font-semibold text-[9px] md:text-[11px] cursor-pointer hover:brightness-95 ${colorClass}`}
            >
              {label}
            </span>
          </button>
        );
      },
    },
    {
      Header: t("agent_col_lock"),
      accessor: "lock",
      align: "center",
      Cell: ({ value, row }) => {
        const isLocked = value === true || value === 1 || value === "1";
        return (
          <button
            type="button"
            onClick={() =>
              handleToggleMemberLock(row.original.Username, isLocked)
            }
            className="w-full flex items-center justify-center text-red-600 hover:text-red-800 py-1"
          >
            {/* Icon always renders so the button keeps a real clickable
                size — `invisible` only hides it visually, it still reserves
                its box, unlike conditionally not rendering it at all. */}
            <LockIcon
              sx={{ fontSize: 18 }}
              className={isLocked ? "" : "invisible"}
            />
          </button>
        );
      },
    },
    {
      Header: t("membertable_col_manage"),
      align: "center",
      Cell: ({ row }) => (
        <div className="flex flex-row items-center space-x-1">
          <button
            onClick={() => handleClickOpen(row.original.Username)}
            className="bg-blue-400 text-white hover:bg-slate-600 hover:text-black p-1 rounded flex items-center justify-center"
          >
            <EditIcon sx={{ fontSize: 16 }} />
          </button>
          <button
            onClick={() => handleClickOpenpassword(row.original.Username)}
            className="bg-yellow-400 text-white hover:bg-slate-600 hover:text-black p-1 rounded flex items-center justify-center"
          >
            <PasswordIcon sx={{ fontSize: 16 }} />
          </button>
          <button
            onClick={() => handleDeletemember(row.original.Username)}
            className="bg-red-400 text-white hover:bg-slate-600 hover:text-black p-1 rounded flex items-center justify-center"
          >
            <DeleteForeverIcon sx={{ fontSize: 16 }} />
          </button>
        </div>
      ),
    },
  ];
  const [transactiom, setTransaction] = useState([]);
  const [opentransaction, setOpentransaction] = React.useState(false);
  const [transactionMember, setTransactionMember] = useState("");

  const handleClosetransaction = () => {
    setOpentransaction(false);
    setTransactionMember("");
  };
  const gettransaction = (agent) => {
    const positionget = {
      user: agent,
    };
    ApiConfig.post("/gettransaction", positionget).then((result) => {
      if (result.resCode === 200) {
        setTransaction(result.data);
        setTransactionMember(agent);
        setOpentransaction(true);
      } else {
        toast.error(result.message || t("common_load_error"), {
          position: "top-right",
          autoClose: 3000,
        });
      }
    });
  };
  const transactioncolumns = [
    {
      Header: t("membertable_tx_col_sender"),
      accessor: "Sender",
      widthClass: "w-1/6",
      Cell: ({ value }) => (
        <span className="font-bold text-[9px] md:text-[11px]">{value}</span>
      ),
    },
    {
      Header: t("membertable_tx_col_receiver"),
      accessor: "Reciever",
      align: "right",
      widthClass: "w-1/6",
      Cell: ({ value }) => (
        <span className="font-bold text-[9px] md:text-[11px]">{value}</span>
      ),
    },
    {
      Header: t("membertable_tx_col_amount"),
      accessor: "Amout",
      align: "center",
      Cell: ({ value }) => {
        const floatValue = parseFloat(value);
        let textColorClass = "text-slate-400"; // Default to black

        if (floatValue > 0) {
          textColorClass = "text-green-600"; // Change to green for positive values
        } else if (floatValue < 0) {
          textColorClass = "text-red-600"; // Change to red for negative values
        }

        return (
          <span
            className={`font-bold text-[9px] md:text-[11px] ${textColorClass}`}
          >
            {floatValue.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </span>
        );
      },
    },
    {
      Header: t("membertable_tx_col_date"),
      accessor: "date_time",
      align: "right",
      widthClass: "w-1/6",
      Cell: ({ value }) => {
        let textColorClass = "text-black";
        let bgColorClass = "bg-amber-200";

        return (
          <div className="flex space-x-2 flex-row">
            <div
              className={`font-bold text-[9px] md:text-[11px] ${bgColorClass} ${textColorClass} rounded-lg border-1 border-black px-2 pt-1`} // Add rounded-md for a rounded border
            >
              {moment(value).format("DD/MM/YYYY HH:mm")}
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <div>
      <TableContainer component={Paper}>
        <div className="p-2 bg-amber-50 border-[1px] border-slate-400 rounded-lg text-xs">
          <div className="p-2 flex items-center">
            <div className="items-center mr-4">
              <p className="font-bold mr-2 text-xs">
                {t("table_search_username")}
              </p>
              <input
                type="text"
                className="p-1 border border-gray-300 rounded text-xs"
                value={memberSearchName}
                onChange={(e) => setMemberSearchName(e.target.value)}
              />
            </div>
            <div className="items-center">
              <p className="font-bold mr-2 text-xs">
                {t("table_search_phone")}
              </p>
              <input
                type="text"
                className="p-1 border border-gray-300 rounded text-xs"
                value={memberSearchPhone}
                onChange={(e) => setMemberSearchPhone(e.target.value)}
              />
            </div>
            <div className="items-center ml-4">
              <p className="font-bold mr-2 text-xs">
                {t("table_search_account_number")}
              </p>
              <input
                type="text"
                className="p-1 border border-gray-300 rounded text-xs"
                value={memberSearchAccount}
                onChange={(e) => setMemberSearchAccount(e.target.value)}
              />
            </div>
            <button
              onClick={handleSearchMemberClick}
              className="mt-4 ml-2 py-1 px-2 bg-blue-500 text-white rounded text-xs"
            >
              {t("table_search_button")}
            </button>
          </div>
        </div>
        {drillDownCrumbs.length > 0 && (
          <div className="px-2 py-1 text-sm font-semibold text-brand-blue-700 flex flex-wrap items-center gap-1">
            {drillDownCrumbs.map((crumb, index) => (
              <React.Fragment key={crumb.href}>
                {index > 0 && <span className="text-brand-blue-400">\</span>}
                <a href={crumb.href} className="hover:underline">
                  {crumb.label}
                </a>
              </React.Fragment>
            ))}
          </div>
        )}
        <div className="overflow-x-auto mt-1">
          <table className="w-full text-[14px]">
            <thead>
              <tr className="bg-gray-100">
                {memberColumns.map((col, idx) => (
                  <th
                    key={`member-col-${idx}`}
                    className="py-1 px-2 text-[14px] whitespace-nowrap"
                    align={col.align}
                  >
                    {col.Header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredMemberRows.map((item, index) => (
                <tr
                  key={item.id ?? item.Username ?? index}
                  className={`transition-colors ${
                    index % 2 === 0 ? "bg-gray-50" : "bg-gray-200"
                  } hover:bg-gray-300`}
                >
                  {memberColumns.map((col, colIdx) => {
                    const row = { original: item, index };
                    const value = col.accessor
                      ? typeof col.accessor === "function"
                        ? col.accessor(item)
                        : item[col.accessor]
                      : undefined;
                    return (
                      <td
                        key={`member-cell-${colIdx}`}
                        className="py-1 px-2 whitespace-nowrap"
                        align={col.align}
                      >
                        {col.Cell ? col.Cell({ value, row }) : value}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </TableContainer>
      {open && userid && userid.Username && (
        <div>
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{ style: { width: "1100px", maxWidth: "95vw" } }}
          >
            <DialogTitle
              className="text-white bg-brand-blue-800"
              id="alert-dialog-title"
              sx={{ fontSize: "1rem", py: 1 }}
            >
              {t("membertable_edit_title_prefix")} {userid && userid.Username}
            </DialogTitle>
            <DialogContent>
              <form className="bg-amber-100 border-[1px] border-slate-200 rounded-lg shadow-md p-3 grid grid-cols-2 gap-2">
                <div className="mb-0">
                  <label
                    className="block text-xs text-gray-700 font-bold mb-1"
                    htmlFor="firstname"
                  >
                    {t("member_first_name")}
                  </label>
                  <input
                    className="w-full text-xs px-2 py-1 text-gray-700 bg-slate-150 border-b-[2px] rounded-lg focus:outline-none focus:border-blue-500"
                    type="text"
                    id="firstname"
                    onChange={(e) => setFname(e.target.value)}
                    value={fname}
                  />
                </div>
                <div className="mb-0">
                  <label
                    className="block text-xs text-gray-700 font-bold mb-1"
                    htmlFor="lastname"
                  >
                    {t("member_last_name")}
                  </label>
                  <input
                    className="w-full text-xs px-2 py-1 text-gray-700 bg-slate-150 border-b-[2px] rounded-lg focus:outline-none focus:border-blue-500"
                    type="text"
                    id="lastname"
                    onChange={(e) => setLname(e.target.value)}
                    value={lname}
                  />
                </div>
                <div className="mb-0">
                  <label
                    className="block text-xs text-gray-700 font-bold mb-1"
                    htmlFor="phone"
                  >
                    {t("member_mobile_number")}
                  </label>
                  <input
                    className="w-full text-xs px-2 py-1 text-gray-700 bg-slate-150 border-b-[2px] rounded-lg focus:outline-none focus:border-blue-500"
                    type="text"
                    id="phone"
                    onChange={(e) => setPhone(e.target.value)}
                    value={phone}
                  />
                </div>
                <div className="mb-0">
                  <label
                    className="block text-xs text-gray-700 font-bold mb-1"
                    htmlFor="bank"
                  >
                    {t("member_bank")}
                  </label>
                  <input
                    className="w-full text-xs px-2 py-1 text-gray-700 bg-slate-150 border-b-[2px] rounded-lg focus:outline-none focus:border-blue-500"
                    type="text"
                    id="bank"
                    onChange={(e) => setBank(e.target.value)}
                    value={bank}
                  />
                </div>
                <div className="mb-0">
                  <label
                    className="block text-xs text-gray-700 font-bold mb-1"
                    htmlFor="banknumber"
                  >
                    {t("member_bank_account_number")}
                  </label>
                  <input
                    className="w-full text-xs px-2 py-1 text-gray-700 bg-slate-150 border-b-[2px] rounded-lg focus:outline-none focus:border-blue-500"
                    type="text"
                    id="banknumber"
                    onChange={(e) => setBanknumber(e.target.value)}
                    value={banknumber}
                  />
                </div>
                <div className="col-span-2 flex justify-end"></div>
              </form>
              <p className="px-2 text-xs text-gray-600">
                {t("membertable_commission_note")}
              </p>
              <MemberCommissionTables
                thCommission={thCommission}
                setThCommission={setThCommission}
                hanoiCommission={hanoiCommission}
                setHanoiCommission={setHanoiCommission}
                laosCommission={laosCommission}
                setLaosCommission={setLaosCommission}
                yeekee5Commission={yeekee5Commission}
                setYeekee5Commission={setYeekee5Commission}
                yeekee10Commission={yeekee10Commission}
                setYeekee10Commission={setYeekee10Commission}
                yeekee15Commission={yeekee15Commission}
                setYeekee15Commission={setYeekee15Commission}
                packages={packages}
                packageIds={packageIds}
                setPackageIds={setPackageIds}
                agentUsername={byAgent ?? user}
              />
            </DialogContent>

            <DialogActions>
              <button
                onClick={() => handleUpdate(userid.Username)}
                className="bg-brand-blue-600 mr-1 hover:bg-brand-blue-700 text-white font-bold py-2 px-4 mr-1 rounded"
              >
                <SaveAltIcon /> {t("membertable_save")}
              </button>
              <button
                onClick={handleClose}
                className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
              >
                {t("common_cancel")}
              </button>
            </DialogActions>
          </Dialog>
        </div>
      )}

      {openeditpassword && (
        <div>
          <Dialog
            open={openeditpassword}
            onClose={handleClosepassword}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
              style: { width: "60%", maxWidth: "100%", margin: 0 },
            }}
          >
            <DialogTitle
              className="text-white bg-brand-blue-800"
              id="alert-dialog-title"
            >
              {t("membertable_change_password_dialog_title_prefix")} {username}
            </DialogTitle>
            <DialogContent>
              <div className="flex w-full flex-col p-2 space-y-2">
                <div className="flex w-[100%] flex-col space-y-2 p-2 rounded-xl border border-[1px]">
                  {/* Content */}
                  <span>{t("membertable_new_password_prompt")}</span>

                  <FormControl sx={{ m: 1, width: "100%" }} variant="standard">
                    <InputLabel htmlFor="standard-adornment-password">
                      {t("login_password_label")}
                    </InputLabel>
                    <Input
                      id="standard-adornment-password"
                      type={showPassword ? "text" : "password"}
                      autoComplete="off"
                      onChange={(e) => handleChangepassword(e)}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </div>
              </div>
            </DialogContent>

            <DialogActions>
              <button
                onClick={() => handleUpdatepassword(password)}
                className="bg-brand-blue-600 mr-1 hover:bg-brand-blue-700 text-white font-bold py-2 px-4 mr-1 rounded"
              >
                <SaveAltIcon /> {t("membertable_save")}
              </button>
              <button
                onClick={handleClosepassword}
                className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
              >
                {t("common_cancel")}
              </button>
            </DialogActions>
          </Dialog>
        </div>
      )}

      {opentransaction && (
        <div>
          <Dialog
            open={opentransaction}
            onClose={handleClosetransaction}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
              style: { width: "60%", maxWidth: "100%", margin: 0 },
            }}
          >
            <DialogTitle
              className="text-white bg-brand-blue-800"
              id="alert-dialog-title"
            >
              <div className="p-1 flex justify-items-center items-center flex-row space-x-2">
                <span className="font-bold text-xs">
                  {t("membertable_credit_history_title")}
                </span>
                <div className="pl-1 pr-1 border-1 bg-yellow-400 rounded-lg drop-shadow-xl text-xs">
                  {t("login_username_label")} : {transactionMember}
                </div>
              </div>
            </DialogTitle>
            <DialogContent>
              <div className="flex w-full flex-col space-y-2">
                <div className="flex w-[100%] flex-col space-y-2 p-2 rounded-xl border border-[1px]">
                  {/* Content */}
                  <MyTable columns={transactioncolumns} data={transactiom} />
                </div>
              </div>
            </DialogContent>
            <DialogActions>
              <button
                onClick={handleClosetransaction}
                className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
              >
                {t("common_cancel")}
              </button>
            </DialogActions>
          </Dialog>
        </div>
      )}

      {openAddCredit && (
        <div>
          <Dialog
            open={openAddCredit}
            onClose={handleCloseAddCredit}
            aria-labelledby="add-credit-dialog-title"
            PaperProps={{ style: { width: "360px", maxWidth: "100%" } }}
          >
            <DialogTitle
              className="text-white bg-brand-blue-800"
              id="add-credit-dialog-title"
            >
              {t("membertable_add_credit_title_prefix")} {creditMember}
            </DialogTitle>
            <DialogContent>
              <div className="flex flex-col space-y-3 pt-3">
                <label className="text-gray-700 font-bold">
                  {t("membertable_credit_amount_label")}
                </label>
                <input
                  type="number"
                  min="1"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-brand-blue-500"
                  value={creditAmount}
                  onChange={(e) => setCreditAmount(e.target.value)}
                  placeholder={t("membertable_credit_amount_placeholder")}
                />
              </div>
            </DialogContent>
            <DialogActions>
              <button
                onClick={handleSubmitAddCredit}
                className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded"
              >
                <SaveAltIcon /> {t("common_confirm")}
              </button>
              <button
                onClick={handleCloseAddCredit}
                className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
              >
                {t("common_cancel")}
              </button>
            </DialogActions>
          </Dialog>
        </div>
      )}
    </div>
  );
}
